import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n        margin-top: 3.75rem;\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { media } from '~layout';
export var FormMainActions = styled.div.withConfig({
  displayName: "FormButtons__FormMainActions",
  componentId: "sc-157ytvz-0"
})(["display:flex;flex-flow:row wrap;justify-content:space-around;margin-top:2rem;", ""], media.sm(_templateObject()));
export var FormMainButton = styled.div.withConfig({
  displayName: "FormButtons__FormMainButton",
  componentId: "sc-157ytvz-1"
})(["margin-bottom:1.25rem;"]);